"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowOutputStepSelector = void 0;
const tslib_1 = require("tslib");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const reselect_1 = require("reselect");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
function createListItems(outputSteps) {
    return outputSteps.map(outputStep => {
        return {
            value: outputStep.id,
            content: outputStep.name || catalog_messages_1.Messages.PermissionsRequired(),
            tooltip: outputStep.name || catalog_messages_1.Messages.PermissionsRequired(),
        };
    });
}
class FlowOutputStepSelector extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.memoizedListItems = (0, reselect_1.defaultMemoize)(createListItems);
    }
    getSelectedOutputStepName() {
        const selectedOutputStep = this.props.outputSteps.find(os => os.id === this.props.selectedOutputStep);
        return selectedOutputStep && selectedOutputStep.name ? selectedOutputStep.name : catalog_messages_1.Messages.PermissionsRequired();
    }
    render() {
        const listItems = this.memoizedListItems(this.props.outputSteps);
        const outputStepName = this.getSelectedOutputStepName();
        return (react_1.default.createElement(widgets_1.SingleSelectDropdown, { label: '', list: react_1.default.createElement(widgets_1.List, { items: listItems, selectedValue: this.props.selectedOutputStep }), type: widgets_1.DropdownButtonType.Outline, value: this.props.selectedOutputStep, onChange: this.props.updateOutputStepSelection, style: data_catalog_shared_1.dropdownStyle },
            react_1.default.createElement(data_catalog_shared_1.DropdownSelectedItem, { title: outputStepName }, outputStepName)));
    }
}
exports.FlowOutputStepSelector = FlowOutputStepSelector;
//# sourceMappingURL=FlowOutputStepSelector.js.map